import PaginaEsito from './PaginaEsito';

// Il backend arriva qui dopo che l'utente ha confermato la cancellazione del profilo.
const AccountCancellato = () => (
    <PaginaEsito titolo="Account cancellato">
        <p>Il tuo account SportId® è stato cancellato.</p>
        <p className="mb-0">Ti abbiamo mandato un'email di conferma.</p>
    </PaginaEsito>
);

export default AccountCancellato;
